export var Style;
(function (Style) {
    Style["Secondary"] = "surface secondary";
})(Style || (Style = {}));
export var StyleContext;
(function (StyleContext) {
    StyleContext["Combobox"] = "combobox";
    StyleContext["ListItem"] = "list-item";
    StyleContext["Input"] = "input";
})(StyleContext || (StyleContext = {}));
export var StyleState;
(function (StyleState) {
    StyleState["Checked"] = "checked";
    StyleState["Disabled"] = "disabled";
    StyleState["Error"] = "error";
})(StyleState || (StyleState = {}));
// #region Figma Tokens
export var BackgroundStyle;
(function (BackgroundStyle) {
    BackgroundStyle["Transparent"] = "bg-transparent";
    BackgroundStyle["Outline"] = "bg-outline";
    BackgroundStyle["Primary"] = "bg-primary";
    BackgroundStyle["High"] = "bg-high";
    BackgroundStyle["Mid"] = "bg-mid";
    BackgroundStyle["Low"] = "bg-low";
    BackgroundStyle["Secondary"] = "bg-secondary";
    BackgroundStyle["Buy"] = "bg-buy";
    BackgroundStyle["Sell"] = "bg-sell";
    BackgroundStyle["Input"] = "bg-input";
})(BackgroundStyle || (BackgroundStyle = {}));
export var ForegroundStyle;
(function (ForegroundStyle) {
    ForegroundStyle["FilledElements"] = "fg-filled-elements";
    ForegroundStyle["OutlineElements"] = "fg-outline-elements";
    ForegroundStyle["HintContent"] = "fg-hint-content";
})(ForegroundStyle || (ForegroundStyle = {}));
export var BorderStyle;
(function (BorderStyle) {
    BorderStyle["General"] = "stroke-general";
    BorderStyle["FocusIndicator"] = "stroke-focus-indicator";
    BorderStyle["OutlineSell"] = "stroke-outline-sell";
    BorderStyle["Input"] = "stroke-input";
})(BorderStyle || (BorderStyle = {}));
export var BorderSize;
(function (BorderSize) {
    BorderSize["None"] = "border-none";
    BorderSize["Solid1"] = "border-solid-1";
})(BorderSize || (BorderSize = {}));
export var StateStyle;
(function (StateStyle) {
    StateStyle["Selected"] = "selected";
})(StateStyle || (StateStyle = {}));
// #endregion Figma Tokens
